import { render } from "./EditCharterersRecord.vue?vue&type=template&id=6cd4467a&scoped=true"
import script from "./EditCharterersRecord.vue?vue&type=script&lang=js"
export * from "./EditCharterersRecord.vue?vue&type=script&lang=js"

import "./EditCharterersRecord.vue?vue&type=style&index=0&id=6cd4467a&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd4467a"]])

export default __exports__